import { useState } from 'react'
import Icon from './Icon'

const SIZES = {
  sm: { box: 'h-7 w-7 text-xs', icon: 14 },
  md: { box: 'h-9 w-9 text-base', icon: 18 },
  lg: { box: 'h-14 w-14 text-xl', icon: 26 },
  xl: { box: 'h-20 w-20 text-3xl', icon: 34 },
}

export default function Avatar({ avatar, username, prenom, size = 'md', className = '' }) {
  const [broken, setBroken] = useState(false)
  const { box, icon } = SIZES[size] || SIZES.md

  const base = `inline-flex ${box} shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-surface-sunken font-medium text-ink-secondary ring-1 ring-inset ring-line ${className}`

  const isImage = avatar && !broken && (avatar.startsWith('data:image') || avatar.startsWith('http'))

  if (isImage) {
    return (
      <span className={base}>
        <img
          src={avatar}
          alt=""
          className="h-full w-full object-cover"
          // Une URL cassée ne doit pas laisser un carré vide : on repasse
          // sur l'initiale via l'état plutôt qu'en réécrivant le DOM.
          onError={() => setBroken(true)}
        />
      </span>
    )
  }

  // Avatar emoji choisi par l'utilisateur dans son profil : il reste légitime
  // ici, c'est une décoration assumée et non une icône d'interface.
  if (avatar && !broken) {
    return (
      <span className={base} aria-hidden="true">
        {avatar}
      </span>
    )
  }

  const initial = (prenom || username || '').trim().charAt(0).toUpperCase()

  return (
    <span className={base} aria-hidden="true">
      {initial || <Icon name="user" size={icon} />}
    </span>
  )
}
